/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../baseClient';
import { 
  SearchPayeeNamesRequest,
  SearchPayeeNamesResponse
 } from '../types';

  //  CorePayorPayeeClient
class CorePayorPayeeClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly lookupNames = (payload: SearchPayeeNamesRequest): AxiosPromise<SearchPayeeNamesResponse> => {
        let url_ = "/api/v1/core/payor/payee_names";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CorePayorPayeeClient
  
export const corePayorPayeeClient = new CorePayorPayeeClient(baseClientConstructorProps);
